import { useI18n } from "@core/i18n/i18n";
import { AnalyticsProgramLocation, sendAnalyticsEventCreateProgram } from "@domain/program/program-analytics";
import styled from "@emotion/styled";
import { Page } from "@ui/components/common/page";
import { PageHeader } from "@ui/components/common/page-header";
import { CreateProgramButton } from "@ui/pages/program/components/create-program-button";
import { physioMeTabletBreakpoint } from "@ui/style";
import React from "react";
import { ValidateAccountCard } from "@ui/pages/home/components/validate-account-card";
import { Tabs } from "@ui/pages/program/components/tabs";

export const TemplateListingPage = (): JSX.Element => {
	const { format } = useI18n();
	const sendAnalytics = () => sendAnalyticsEventCreateProgram(AnalyticsProgramLocation.PROGRAM_PAGE);

	return (
		<StyledPage>
			<ValidateAccountCard showForPendingPt={false} />
			<PageHeader title={format("tabbar.programs")} primaryButton={<CreateProgramButton onClick={sendAnalytics} />} />
			<Card className="p-card">
				<Tabs />
			</Card>
		</StyledPage>
	);
};

const StyledPage = styled(Page)`
	@media ${physioMeTabletBreakpoint} {
		padding: 0;
		max-width: 100%;
	}
`;

const Card = styled.div`
	padding: 32px;
	width: 1280px;
	max-width: 100%;

	@media ${physioMeTabletBreakpoint} {
		padding: 0;
		flex: 1;
	}
`;
